// extracted by mini-css-extract-plugin
var _1 = "Dashboard__Dashboard--d2pNX";
export { _1 as "Dashboard" }
